import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateWorkflow, useWorkflow } from "../hooks";

export default function WorkflowEditPage() {
  const { workflowId } = useParams();
  const id = Number(workflowId);
  const navigate = useNavigate();

  const { data, isLoading } = useWorkflow(id);
  const update = useUpdateWorkflow();

  const [form, setForm] = useState({
    name: "",
    description: "",
    active: true,
    defaultWorkflow: false,
  });

  useEffect(() => {
    if (data) {
      setForm({
        name: data.name,
        description: data.description ?? "",
        active: data.active,
        defaultWorkflow: data.defaultWorkflow,
      });
    }
  }, [data]);

  async function submit() {
    await update.mutateAsync({ id, payload: form });
    navigate(`/admin/workflows/${id}`);
  }

  if (isLoading) return <p className="p-6">Loading workflow...</p>;

  return (
    <div className="mx-auto max-w-2xl space-y-6 p-6">
      <button
        onClick={() => navigate(`/admin/workflows/${id}`)}
        className="flex items-center gap-1 text-sm text-slate-500 hover:text-slate-800"
      >
        ← Back to Workflow
      </button>

      <div>
        <h1 className="text-2xl font-bold">Edit Workflow</h1>
        <p className="text-sm text-slate-500">
          Update workflow name, description, active status and default setting.
        </p>
      </div>

      <div className="space-y-4 rounded-2xl border bg-white p-5">
        <Field label="Name">
          <input
            className="input"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
        </Field>

        <Field label="Description">
          <textarea
            className="input min-h-24"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
        </Field>

        <label className="flex items-center gap-2 rounded-xl border p-3 text-sm">
          <input
            type="checkbox"
            checked={form.active}
            onChange={(e) => setForm({ ...form, active: e.target.checked })}
          />
          Active
        </label>

        <label className="flex items-center gap-2 rounded-xl border p-3 text-sm">
          <input
            type="checkbox"
            checked={form.defaultWorkflow}
            onChange={(e) =>
              setForm({ ...form, defaultWorkflow: e.target.checked })
            }
          />
          Default workflow for this module
        </label>

        <div className="flex justify-end gap-2">
          <button
            onClick={() => navigate(`/admin/workflows/${id}`)}
            className="rounded-xl border px-4 py-2"
          >
            Cancel
          </button>

          <button
            onClick={submit}
            disabled={update.isPending}
            className="rounded-xl bg-emerald-600 px-4 py-2 font-semibold text-white disabled:opacity-50"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
}

function Field({ label, children }: any) {
  return (
    <label className="block space-y-1 text-sm">
      <span className="font-medium text-slate-700">{label}</span>
      {children}
    </label>
  );
}